import React, { FC } from 'react'
import TextType, { TextProps } from './TextType'

const NumberType: FC<TextProps> = ({ ...rest }) => <TextType type="number" {...rest} />

export default NumberType
